import type { IconSvgObject } from './types';

const SquareMIcon: IconSvgObject = [
  ["path", { d: "M2.49997 19.5V4.5C2.49997 3.39543 3.3954 2.5 4.49997 2.5H19.5C20.6045 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6045 21.5 19.5 21.5H4.49997C3.3954 21.5 2.49997 20.6046 2.49997 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.99997 16V8L12 13L16 8V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareMIcon;
